import {gql, useQuery} from "@apollo/client";
import {useMutation} from "@apollo/react-hooks";
import React, {useState} from "react";
import MainButton from "../forms/Buttons";
import {addCurrentFullProfile} from "../../../store/actions/FullProfileActions";
import {setFullProfilePlayerId} from "../../../store/actions/Dashboard/FullProfile/FullProfileActions";
import {addWatchlist} from "../../../store/actions/WatchlistActions";
import {connect} from "react-redux";
import {setRefetch} from "../../../store/actions/Dashboard/Watchlist/WatchlistActions";

/**
 * Renders the button of add player to watch list.
 */
const AddToWatchListButton = props => {
    const {playerId, updateWatchlist} = props;

    const ADD_TO_WATCH_LIST = gql`
        mutation AddToWatchlist($playerId: String!){
            addToWatchlist(
                user: "5e9c3e2c2e57ff7e65742d0c"
                players: [$playerId]
            ){
                id
            }
        }
    `;

    const REMOVE_FROM_WATCH_LIST = gql`
        mutation RemoveFromWatchlist($playerId: String!){
            removeFromWatchlist(
                players: [ $playerId ]
            )
        }
    `;

    const GET_WATCH_LIST = gql`
        query getWatchList{
            watchList: userWatchlist (user: "5e9c3e2c2e57ff7e65742d0c"){
                results{
                    player{
                        id
                    }
                }
            }
        }
    `;

    const variables = {playerId};
    const [addToWatchList, {loading: addLoading, error: addError}] = useMutation(ADD_TO_WATCH_LIST, {
        refetchQueries: [{query: GET_WATCH_LIST, variables}],
        // awaitRefetchQueries: true,
    });
    const [removeFromWatchList, {loading: removeLoading, error: removeError}] = useMutation(REMOVE_FROM_WATCH_LIST, {
        refetchQueries: [{query: GET_WATCH_LIST, variables}],
        // awaitRefetchQueries: true,
    });
    const {loading: queryLoading, error: queryError, data} = useQuery(GET_WATCH_LIST, {
        variables,
        // notifyOnNetworkStatusChange: true
    });


    const addToWatchlistText = "Add to watchlist";
    const removeFromWatchListText = "Remove from watchlist";
    const [buttonText, setButtonText] = useState(addToWatchlistText);
    const [added, setAdded] = useState(false);// TODO:

    const loading = queryLoading || addLoading || removeLoading;
    const error = queryError || addError || removeError;

    if (loading) return <MainButton sm text={"Loading..."} disabled={true}/>;
    else if (error) return "Error";
    const handleButtonClick = () => {
        const variables = {playerId};

        if (!added) {
            addToWatchList({variables}).then(result => {
                setButtonText(removeFromWatchListText);
                setAdded(!added);
                updateWatchlist();

            }).catch(error => {
                alert("Error");
            });

        } else {
            removeFromWatchList({variables}).then(result => {
                setButtonText(addToWatchlistText);
                setAdded(!added);
                updateWatchlist();

            }).catch(error => {
                alert("Error");
            });
        }
    };

    return (
        <MainButton sm text={buttonText} loading={loading} error={error} onClick={handleButtonClick}/>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        updateWatchlist: () => dispatch(setRefetch(true)),
    }
};

export default connect(null, mapDispatchToProps)(AddToWatchListButton);
